<template>
  <div>
    <h1>AddOthersAccount</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>